import React, { useState } from "react";
import HeaderStats from "../Common/Header";
import FiltersStats from "../Common/Filters";
import ExportDiagram from "./ExportDiagram";

const FormExportDiagram: React.FC = () => {
    const [activeFilters, setActiveFilters] = useState<FiltersStatsInterface>();

    return (
        <React.Fragment>
            <HeaderStats />
            <FiltersStats
                setActiveFilters={setActiveFilters}
            />

            <div className="stats" style={{ marginTop: "50px", marginBottom: "150px" }}>
                <div className="container container--table bloc_tabs">
                    <div className="bloc">
                        {activeFilters && <ExportDiagram activeFilters={activeFilters} />}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default FormExportDiagram;
